import React, { useState } from 'react';
import '../../assets/css/imagefilters.css';

// Predefined filters - each is a preset combination of effects
export const PRESET_FILTERS = {
  original: {
    css: "",
  },
  invert: {
    css: "invert(100%)",
  },
  grayscale: {
    css: "grayscale(100%)",
  },
  sepia: {
    css: "sepia(100%)",
  },
  vintage: {
    css: "sepia(40%) contrast(90%) saturate(80%) brightness(110%)",
  },
  cool: {
    css: "hue-rotate(180deg) saturate(120%)",
  },
  warm: {
    css: "sepia(25%) saturate(115%)",
  },
};

const PRESET_FILTERS_DEMO = {
  original: {
    name: 'Original',
    brightness: 100,
    contrast: 100,
    saturation: 100,
    grayscale: 0,
    sepia: 0,
    hueRotate: 0,
    blur: 0,
  },
  grayscale: {
    name: 'Grayscale',
    brightness: 100,
    contrast: 100,
    saturation: 0,
    grayscale: 100,
    sepia: 0,
    hueRotate: 0,
    blur: 0,
  },
  invert: {
    name: 'Invert',
    brightness: 100,
    contrast: 100,
    saturation: 100,
    grayscale: 0,
    sepia: 0,
    hueRotate: 180,
    blur: 0,
  },
  vintage: {
    name: 'Vintage',
    brightness: 110,
    contrast: 90,
    saturation: 80,
    grayscale: 0,
    sepia: 40,
    hueRotate: 10,
    blur: 0,
  },
  cool: {
    name: 'Cool',
    brightness: 95,
    contrast: 110,
    saturation: 120,
    grayscale: 0,
    sepia: 0,
    hueRotate: 200,
    blur: 0,
  },
  warm: {
    name: 'Warm',
    brightness: 110,
    contrast: 100,
    saturation: 130,
    grayscale: 0,
    sepia: 20,
    hueRotate: 15,
    blur: 0,
  },
  vivid: {
    name: 'Vivid',
    brightness: 100,
    contrast: 130,
    saturation: 150,
    grayscale: 0,
    sepia: 0,
    hueRotate: 0,
    blur: 0,
  },
};

const ImageFiltersPanel = ({
  imageId,
  item,
  disabled = false,
  onUpdate,
}) => {
  if (!item) return null;

  const handleFilterApply = (filterKey) => {
    onUpdate(imageId, "presetFilter", filterKey);
  };

  // Determine which filter is currently active
  const currentFilterKey = Object.keys(PRESET_FILTERS_DEMO).find((key) => {
    const filter = PRESET_FILTERS_DEMO[key];
    return (
      item.brightness === filter.brightness &&
      item.contrast === filter.contrast &&
      item.saturation === filter.saturation &&
      item.grayscale === filter.grayscale &&
      item.sepia === filter.sepia &&
      item.hueRotate === filter.hueRotate &&
      item.blur === filter.blur
    );
  }) || 'original';

  return (
    <div className="image-filters-panel">
      <h4 className="filters-title">Image Filters</h4>

      <div className="filters-grid">
        {Object.entries(PRESET_FILTERS).map(([key, filter]) => {
          const isActive = currentFilterKey === key;

          // Build CSS for preview thumbnail
          const filterStyle = {
            filter: PRESET_FILTERS[key].css,
          };

          return (
            <button
              key={key}
              type="button"
              disabled={disabled}
              className={`filter-button ${isActive ? 'active' : ''}`}
              onClick={() => handleFilterApply(key)}
              title={filter.name}
            >
              {/* Thumbnail preview with filter applied */}
              <div className="filter-preview-image">
                <div
                  className="filter-preview-icon"
                  style={{
                    backgroundImage: item.imageDataUrl
                      ? `url('${item.imageDataUrl}')`
                      : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    ...filterStyle,
                  }}
                />
              </div>

              {/* Filter name label */}
              {/* <span className="filter-label">{filter.name}</span> */}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ImageFiltersPanel;
